<div *ngIf="info" class="footer fixed bottom-0 z-40 flex w-full items-center bg-gray-200 px-4 lg:px-6">
  <span class="mr-2 overflow-hidden text-xs text-ellipsis whitespace-nowrap">
    {{ info?.versionInfo }}
  </span>
  <span *ngIf="info?.urlDescription" class="mr-1 text-xs">©</span>
  <a
    [href]="info?.url"
    class="text-left text-xs leading-tight font-medium whitespace-nowrap text-blue-400 no-underline hover:text-blue-700"
    >{{ info?.urlDescription }}</a
  >
</div>
